import axios from 'axios';

import AuthService from './AuthService';
import { API_URL, PDF_URL } from './constants';

interface PDFRequest {
  reportId?: string;
  filename?: string;
  destination?: string;
  orientation?: string;
  localStorage?: object;

  appendPricing?: string;
}

export default class PdfService {
  static generate(url: string, data: PDFRequest) {
    return new Promise((resolve, reject) => {
      const apiUrl = API_URL;

      axios({
        method: 'POST',
        url: PDF_URL + '/generate',
        data: { url, apiUrl, ...data },
        headers: { ...axios.defaults.headers, Authorization: AuthService.getToken() },
      })
        .then((result) => {
          resolve(result.data);
        })
        .catch((err) => {
          reject(err);
        });

      return;
    });
  }
}
